import { render } from "./DriveMediaViewSlide.vue?vue&type=template&id=64b7d8ec&scoped=true&ts=true"
import script from "./DriveMediaViewSlide.vue?vue&type=script&lang=ts"
export * from "./DriveMediaViewSlide.vue?vue&type=script&lang=ts"

import "./DriveMediaViewSlide.vue?vue&type=style&index=0&id=64b7d8ec&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b7d8ec"]])

export default __exports__